import React from 'react';

/**
 * 侧边栏组件
 * 提供可拖拽的节点类型，用户可以从这里拖拽节点到画布上
 */
const Sidebar: React.FC = () => {
  /**
   * 处理拖拽开始事件
   * @param event - 拖拽事件
   * @param nodeType - 节点类型
   */
  const onDragStart = (event: React.DragEvent, nodeType: string) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h3>节点库</h3>
        <p>拖拽节点到画布上</p>
      </div>
      
      <div className="sidebar-content">
        {/* 大模型节点 */}
        <div
          className="dndnode llm"
          onDragStart={(event) => onDragStart(event, 'llm')}
          draggable
        >
          <div className="node-icon">LLM</div>
          <div className="node-info">
            <div className="node-title">LLM</div>
            <div className="node-description">大语言模型处理</div>
          </div>
        </div>

        {/* 代码执行节点 */}
        <div
          className="dndnode code"
          onDragStart={(event) => onDragStart(event, 'code')}
          draggable
        >
          <div className="node-icon">&lt;/&gt;</div>
          <div className="node-info">
            <div className="node-title">代码执行</div>
            <div className="node-description">执行代码逻辑</div>
          </div>
        </div>

        {/* 判断节点 */}
        <div
          className="dndnode condition"
          onDragStart={(event) => onDragStart(event, 'condition')}
          draggable
        >
          <div className="node-icon">IF</div>
          <div className="node-info">
            <div className="node-title">条件分支</div>
            <div className="node-description">条件判断逻辑</div>
          </div>
        </div>
      </div>

      <div className="sidebar-footer">
        <p className="tip">💡 提示：拖拽节点到右侧画布创建工作流</p>
      </div>
    </aside>
  );
};

export default Sidebar; 